import gql from 'graphql-tag';
import { RemoveCartItem, ShoppingCart } from '@buy-viasat/types/build/bv';
import { client } from 'shared/containers/apollo';
import { ShoppingCartFragment } from './fragments';
import { FetchResult } from '@apollo/client';

export type RemoveCartItemResponse = FetchResult<{ removeCartItem: ShoppingCart }>;

const REMOVE_CART_ITEM = gql`
  mutation removeCartItem($input: RemoveCartItem!) {
    removeCartItem(input: $input) {
      ...ShoppingCart
    }
  }
  ${ShoppingCartFragment}
`;

export default async function removeCartItemAsync({
  input,
}: {
  input: RemoveCartItem;
}): Promise<RemoveCartItemResponse> {
  return client.mutate({
    mutation: REMOVE_CART_ITEM,
    variables: { input },
  });
}
